import React from 'react';
import styles from './FatalErrorMessage.module.scss';
import { useTranslation } from 'react-i18next';

interface FatalErrorMessageProps {
  errorMessage?: string;

  // This component is used as a fallback for Sentry.ErrorBoundary. These props are passed by Sentry.ErrorBoundary.
  error?: Error;
  componentStack?: string;
  eventId?: string;
  resetError?: () => void;
}

export default function FatalErrorMessage({ errorMessage }: FatalErrorMessageProps) {
  const { t } = useTranslation();
  return (
    <div className={styles.container}>
      <div style={{ textAlign: 'center', padding: '2rem' }}>
        {errorMessage ?? t('an_error_occurred_loading_this_page_if_problem_persists_reach_out_to_support_tryfi_com')}
      </div>
    </div>
  );
}
